import { Routing } from '@briq/core'

import { useRegisterPageConfig } from './registerPageConfig'
import { useCartConfig } from './cartPageConfig'
import { useCheckoutConfig } from './checkoutConfig'
import { useArchiveReportsPageConfig } from './archiveReportsConfig'

export const routeComponentOverrideConfig: Routing.RouteOverrideConfig = {
  [Routing.Routes.Cart]: {
    ...Routing.routesComponentConfig[Routing.Routes.Cart],
    createConfig: useCartConfig
  },
  [Routing.Routes.Checkout || Routing.Routes.Billing || Routing.Routes.Payment || Routing.Routes.Confirmation]: {
    ...Routing.routesComponentConfig[Routing.Routes.Checkout],
    createConfig: useCheckoutConfig
  },
  [Routing.Routes.Register]: {
    ...Routing.routesComponentConfig[Routing.Routes.Register],
    createConfig: useRegisterPageConfig
  },
  [Routing.Routes.ArchiveReports]: {
    ...Routing.routesComponentConfig[Routing.Routes.ArchiveReports],
    createConfig: useArchiveReportsPageConfig
  }
}
